import ReactModal from 'react-modal';

export const setAppElement = (element: HTMLElement | string) => {
  ReactModal.setAppElement(element);
};
